import { File } from '../types';

const icon = {
  pdf: 'file-pdf-line',
  doc: 'file-word-line',
  docx: 'file-word-line',
  xls: 'file-excel-line',
  xlsx: 'file-excel-line',
  ppt: 'file-powerpoint-line',
  pptx: 'file-powerpoint-line',
  zip: 'file-archive-line',
  rar: 'file-archive-line',
  txt: 'file-alt-line',
  jpg: 'file-image-line',
  jpeg: 'file-image-line',
  png: 'file-image-line',
  gif: 'file-image-line',
  svg: 'file-image-line',
  mp4: 'file-video-line',
  mov: 'file-video-line',
  avi: 'file-video-line',
  mp3: 'file-audio-line',
  wav: 'file-audio-line',
  flac: 'file-audio-line',
  otf: 'font-family',
  ttf: 'font-family',
  default: 'file-line',
} as const;

export function FileItem({ name, url }: File) {
  const fileType = icon[url.split('.').pop() as keyof typeof icon] ? url.split('.').pop() : 'default';

  return (
    <div className="flex gap-2 items-center">
      <i className={`ri-${icon[fileType as keyof typeof icon]} text-lg`} />
      <a href={url} target="_blank" rel="noreferrer" className='text-black'>
        {name}
      </a>
    </div>
  );
}
